export default {"src":"/_next/static/media/PSA.572cb7c3.svg","height":18,"width":18};